<template lang="pug">
div(:class="'container-'+this._uid+' '+this.classes")
  h1(class="section-title") {{this.title}}
  vue-markdown.desc(:source='this.desc')

  div(class="section-content")
    section.row(v-for="(n, i) in this.payload.fields.content" :class="n.classes")
      h3.title
        vue-markdown(:source='n.fields.title')
      div.splitMiddle
        div.splitLeft
          img(:src='n.fields.image.fields.file.url' :alt='n.fields.image.fields.file.fileName')
        div.splitRight
          vue-markdown.desc(:source='n.fields.body || n.fields.desc')
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/sectionBase.js'

// component instance
var textblockImgRight = Vue.component('textblock-img-right', {
  name: 'textblockImgRight',
  mixins: [sectionBase],
  props: [],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default textblockImgRight
</script>

<style scoped>
  .page-title{

  }
</style>



// WEBPACK FOOTER //
// src/components/sections/textblockImgRight.vue